import React, {lazy} from "react";
import {Route, Routes, Navigate} from "react-router-dom";
import {createMemoryHistory} from "history";
import {retryFailLoad} from "data/utils";
import {NotAuthOnlyRoute, PrivateRoute, SecondStepSsoRoute} from "views/components/route";
import {GeoBlocking} from "views/components/route/geo_blocking_route/geo_blocking.component";
import {EndSeason} from "views/components/route/end_season/end_season.component";
import RegistrationTermsPage from 'views/pages/registartion_terms/registration_terms.page';
import {GigyaGate} from 'views/components/gigya_gate/gigya_gate.component';

const LightPredictor = lazy(
	retryFailLoad(() => import("views/pages/light_predictor/light_predictor.page"))
);
const HeavyPredictor = lazy(
	retryFailLoad(() => import("views/pages/heavy_predictor_page/heavy_predictor_page.page"))
);
// const Dashboard = lazy(retryFailLoad(() => import("views/pages/dashboard/dashboard.page")));
const OffSeason = lazy(retryFailLoad(() => import("views/pages/off_season/off_season.page")));
const Login = lazy(retryFailLoad(() => import("views/pages/login/login.page")));
const Registration = lazy(
	retryFailLoad(() => import("views/pages/registration/registration.page"))
);
const ForgotPassword = lazy(
	retryFailLoad(() => import("views/pages/forgot_password/forgot_password.page"))
);
const ResetPassword = lazy(
	retryFailLoad(() => import("views/pages/reset_password/reset_password.page"))
);
const Account = lazy(retryFailLoad(() => import("views/pages/account/account.page")));
const UpdateAccount = lazy(
	retryFailLoad(() => import("views/pages/account/update_account/update_account.page"))
);
const NflAccount = lazy(
	retryFailLoad(() => import("views/pages/account/nfl_account/nfl_account.page"))
);
const CommunicationAccount = lazy(
	retryFailLoad(
		() => import("views/pages/account/communication_account/communication_account.page")
	)
);
const Help = lazy(retryFailLoad(() => import("views/pages/help/help.page")));
const NotFound = lazy(retryFailLoad(() => import("views/pages/not_found/not_found.page")));
const ComponentsReview = lazy(
	retryFailLoad(() => import("views/pages/components_review/components_review.page"))
);

const MyLeagues = lazy(retryFailLoad(() => import("views/pages/my_leagues/my_leagues.page")));
const JoinLeagues = lazy(retryFailLoad(() => import("views/pages/join_leagues/join_leagues.page")));
const CreateLeague = lazy(
	retryFailLoad(() => import("views/pages/create_league/create_league.page"))
);
const League = lazy(retryFailLoad(() => import("views/pages/league/league.page")));
const LeagueSettings = lazy(
	retryFailLoad(() => import("views/pages/league_settings/league_settings.page"))
);
const LeagueInvite = lazy(
	retryFailLoad(() => import("views/pages/league_invite/league_invite.page"))
);
const LeagueAbout = lazy(retryFailLoad(() => import("views/pages/league_about/league_about.page")));

export const RootRoutes: React.FC = () => {
	const history = createMemoryHistory();

	if (window.location.search.includes("gig_actions")) {
		history.push(history.location.pathname);
	}

	return (
		<Routes>
			<Route element={<GigyaGate/>}>
				<Route element={<GeoBlocking/>}>
					<Route element={<SecondStepSsoRoute/>}>
						<Route element={<EndSeason/>}>
							{/*<Route path="/dashboard" element={<Dashboard />} />*/}
							<Route index path="/" element={<Navigate to="/pick-by-seed"/>}/>
							<Route path="/pick-by-seed" element={<LightPredictor/>}/>
							<Route path="/game-by-game" element={<HeavyPredictor/>}/>
							<Route path="/off-season" element={<OffSeason/>}/>

							<Route element={<NotAuthOnlyRoute/>}>
								<Route path="/login" element={<Login/>}/>
								<Route path="/forgot-password" element={<ForgotPassword/>}/>
								<Route path="/reset-password" element={<ResetPassword/>}/>
							</Route>
							<Route element={<PrivateRoute/>}>
								<Route path="/account" element={<Account/>}>
									<Route index element={<Navigate to="update"/>}/>
									<Route path="update" element={<UpdateAccount/>}/>
									<Route path="communications" element={<CommunicationAccount/>}/>
									<Route path="nfl-account" element={<NflAccount/>}/>
								</Route>
								<Route path="/leagues" element={<MyLeagues/>}/>
								<Route path="/leagues/join" element={<JoinLeagues/>}>
									<Route index path=":code" element={<JoinLeagues/>}/>
								</Route>
								<Route path="/leagues/create" element={<CreateLeague/>}/>
								<Route path="/league/:leagueId" element={<League/>}>
									<Route path="invite" element={<LeagueInvite/>}/>
									<Route path="settings" element={<LeagueSettings/>}/>
									<Route path="about" element={<LeagueAbout/>}/>
								</Route>
							</Route>
						</Route>
					</Route>

					<Route element={<NotAuthOnlyRoute/>}>
						<Route path="/registration" element={<Registration/>}/>
					</Route>
					<Route element={<PrivateRoute/>}>
						<Route path="/registration/terms" element={<RegistrationTermsPage/>}/>
					</Route>
				</Route>
			</Route>

			<Route path="components" element={<ComponentsReview />} />
			<Route path="help/*" element={<Help />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};

export default RootRoutes;
